import * as React from "react";

interface Props {
  result: ClientSiteAssessmentResultsDTO;
  canSeeScores: boolean;
}

export const VitalsScoreCell: React.FC<Props> = ({ result, canSeeScores }) => {
  const { vitalsScore, vitalsDateCompleted, vitalsTestResultId } = result;
  if (canSeeScores && vitalsScore !== undefined) return <>{vitalsScore}</>;
  if (vitalsDateCompleted) return <>C</>;
  if (!vitalsTestResultId) return <>-</>;
  return <>NC</>;
};
